<template>
  <div class="referral-statistics">
    <div class="referral-statistics__search">
      <div class="referral_link">
        <span class="referral_link__title">Реферальная ссылка</span>
        <div class="referral_link__wrapper">
          <span class="referral_link__value">{{ link }}</span>
          <img
            class="referral_link__copy"
            src="@/assets/icons/icon-copy-clip.svg"
            alt="copy link"
            @click="doCopy"
          />
        </div>
        <div class="referral_link__wrapper">
          <span class="referral_link__value">{{ agentLink }}</span>
          <img
            class="referral_link__copy"
            src="@/assets/icons/icon-copy-clip.svg"
            alt="copy link"
            @click="doCopyAgentLink"
          />
        </div>
      </div>
      <!-- <Search :placeholder="$t('search_props.placeholder')" @findValue="changeSearchText" /> -->
    </div>
    <!-- <div v-if="usersList" class="referral-statistics__table" :class="{ 'locale-usa': locale === 'USA' }">
            <el-table 
            :data="usersList" 
            :show-header="false" 
            style="width: 100%" 
            :row-class-name="tableRowClassName">
                <el-table-column min-width="200">
                    <template slot-scope="scope">
                        <div class="higlited-title">
                            {{ (scope.row.email) }}
                        </div>
                    </template>
</el-table-column>
<el-table-column width="300">
    <template slot-scope="scope">
                        <div class="higlited-title button-style" @click="getDetailStatistics(scope.row.id)">
                            Получить детальную статистику 
                        </div>
                    </template>
</el-table-column>
<div class="el-table__empty-block" slot="append" v-if="!usersList || usersList == '0'">
    <p class="el-table__empty-text ">{{ locale === 'RU' ? 'Нет данных' : 'No data' }}</p>
</div>
</el-table>
<div v-if="pagination && pagination.total > 15 && pagination.lastPage !== currentPage" class="ad-page__accounts-more"
    :class="{ 'locale-usa': locale === 'USA' }" @click="showMore">
    <img :src="getPic(locale)" alt="icon">
    {{ $t('show_more') }}
</div>
</div> -->
    <div class="referral-statistics">
      <div class="referral-statistics-header">
        <div class="referral-statistics__tabs">
          <div
            :class="['referral-statistics__tab', { active: activeTab === 'business' }]"
            @click="activeTab = 'business'"
          >
            Бизнес-аккаунты
          </div>
          <div
            :class="['referral-statistics__tab', { active: activeTab === 'referrals' }]"
            @click="activeTab = 'referrals'"
          >
            Реферальные ссылки
          </div>
        </div>
        <button
          :class="['referral-statistics-button__create', { active: activeTab === 'referrals' }]"
          @click="openPrepaidDialog"
        >
          Создать реферальную ссылку
        </button>
      </div>

      <div v-if="activeTab === 'business'" v-loading="isLoadingBusinessAccount">
        <div v-if="usersList && usersList.length" class="referral-statistics__table-title">
          Бизнес-аккаунты
        </div>
        <div v-if="usersList && usersList.length" class="referral-statistics__table">
          <div v-for="item in usersList" :key="item.id" class="referral-statistics__row">
            <div style="position: relative">
              {{ item.email }}
              <Tooltip :data="item.link_name" />
            </div>
            <div class="referral-statistics__row-actions">
              <button
                v-if="item.business_account_id"
                type="button"
                class="referral-statistics__login-business-account-btn"
                @click="loginBusinessAccount(item.business_account_id)"
              >
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.69231 10.7118C9.69231 8.8669 11.2077 7.37133 13.0769 7.37133H18C18.5098 7.37133 18.9231 7.77921 18.9231 8.28236C18.9231 8.78551 18.5098 9.19339 18 9.19339H13.0769C12.2273 9.19339 11.5385 9.87319 11.5385 10.7118V11.9265C11.5385 12.4296 11.1252 12.8375 10.6154 12.8375C10.1056 12.8375 9.69231 12.4296 9.69231 11.9265V10.7118ZM10.6154 23.1625C11.1252 23.1625 11.5385 23.5704 11.5385 24.0735V25.2882C11.5385 26.1268 12.2273 26.8066 13.0769 26.8066H18C18.5098 26.8066 18.9231 27.2145 18.9231 27.7176C18.9231 28.2208 18.5098 28.6287 18 28.6287H13.0769C11.2077 28.6287 9.69231 27.1331 9.69231 25.2882V24.0735C9.69231 23.5704 10.1056 23.1625 10.6154 23.1625Z"
                    fill="#395FE4"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.9231 9.34341C18.9231 8.28589 19.9911 7.55226 20.9959 7.91955L27.1497 10.169C27.7532 10.3896 28.1538 10.9577 28.1538 11.5929V24.4071C28.1538 25.0423 27.7532 25.6104 27.1497 25.831L20.9959 28.0804C19.9911 28.4477 18.9231 27.7141 18.9231 26.6566V9.34341ZM21.6371 6.21092C19.4265 5.40288 17.0769 7.01686 17.0769 9.34341V26.6566C17.0769 28.9831 19.4265 30.5971 21.6371 29.7891L27.7909 27.5396C29.1187 27.0543 30 25.8045 30 24.4071V11.5929C30 10.1954 29.1187 8.9457 27.7909 8.46036L21.6371 6.21092Z"
                    fill="#395FE4"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.1934 14.9264C11.5539 14.5706 12.1384 14.5706 12.4989 14.9264L14.9604 17.3558C15.3209 17.7116 15.3209 18.2884 14.9604 18.6442L12.4989 21.0736C12.1384 21.4294 11.5539 21.4294 11.1934 21.0736C10.833 20.7178 10.833 20.141 11.1934 19.7852L12.0792 18.911H6.92308C6.41328 18.911 6 18.5032 6 18C6 17.4969 6.41328 17.089 6.92308 17.089H12.0792L11.1934 16.2148C10.833 15.859 10.833 15.2822 11.1934 14.9264Z"
                    fill="#395FE4"
                  />
                </svg>
              </button>
              <div class="higlited-title button-style" @click="getDetailStatistics(item.id)">
                Получить детальную статистику
              </div>
            </div>
          </div>
        </div>
        <div v-else class="app-add-business-account">
          <div class="app-no-data__title">{{ $t('referral_data.no_referral') }}</div>
          <div class="app-no-data__text">{{ $t('referral_data.invite_referrals') }}</div>
          <ButtonElement
            :text="$t('button_props.send_invitations')"
            class="app-no-data__button"
            @click-button="sendInvitations"
          />
        </div>
      </div>

      <div v-else-if="activeTab === 'referrals'">
        <div class="referral-statistics">
          <div v-if="agentsLinksList" class="referral_list" :key="agentsLinksList.length">
            <div class="referral_list-item" v-for="item in agentsLinksList" :key="item.id">
              <div @click="openReferralDialog(item.referral_code)" class="referral_list-name">
                {{ item.title }}
              </div>
              <div>
                <div class="referral_link__wrapper">
                  <span class="referral_link__value">{{ item.link }}</span>
                  <img
                    class="referral_link__copy"
                    src="@/assets/icons/icon-copy-clip-grey.svg"
                    alt="copy link"
                    @click="copyReferralLink(item.link)"
                  />
                </div>
                <div class="referral_link__wrapper">
                  <span class="referral_link__value"
                    >https://profitads.ru/?agent_id={{ item.referral_code }}</span
                  >
                  <img
                    class="referral_link__copy"
                    src="@/assets/icons/icon-copy-clip-grey.svg"
                    alt="copy link"
                    @click="
                      copyReferralLink(`https://profitads.ru/?agent_id=${item.referral_code}`)
                    "
                  />
                </div>
                <!-- <div v-for="(url, urlIndex) in item.urls" :key="urlIndex" class="referral_link__block">
                                    <span class="referral_link__value">{{ url }}</span>
                                    <img class="referral_link__copy" src="@/assets/icons/icon-copy-clip-grey.svg" alt="copy link"
                                        @click="doCopyAgentLink">
                                </div> -->
              </div>
            </div>
          </div>
          <!-- <div class="referral_link__wrapper">
                            <span class="referral_link__value">{{ link }}</span>
                            <img class="referral_link__copy" src="@/assets/icons/icon-copy-clip.svg" alt="copy link"
                                @click="doCopy">
                        </div> -->
          <!-- <div class="referral_link__wrapper">
                            <span class="referral_link__value">{{ agentLink }}</span>
                            <img class="referral_link__copy" src="@/assets/icons/icon-copy-clip.svg" alt="copy link"
                                @click="doCopyAgentLink">
                        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Tooltip from '@/components/elements/Tooltip';

const tableRowClassName = ({ row }) => {
  if (row.has_new_comment) {
    return 'higlited';
  }
  return '';
};

// import Search from "@/components/sort/Search";
import ButtonElement from '@/components/elements/ButtonElement';
import { METRIKA_GOALS, reachMetrikaGoal } from '@/utils/metrika';
export default {
  name: 'ReferralStatistics',
  components: { ButtonElement, Tooltip },
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
      tableRowClassName,
      isLoadingBusinessAccount: false,
      currentPage: 1,
      activeTab: 'business',
      links: [
        {
          name: 'Вконтакте 3%',
          id: '674EF9911E96C',
          urls: [
            'https://profitads.ru/?agent_id=6698B632DBC61',
            'https://lk.profitads.ru/registration/6698B632DBC61',
          ],
        },
        {
          name: 'My Target 10%',
          id: '674EF9911E96C',
          urls: [
            'https://profitads.ru/?agent_id=6698B632DBC61',
            'https://lk.profitads.ru/registration/6698B632DBC61',
          ],
        },
        {
          name: 'Facebook 15%',
          id: '674EF9911E96C',
          urls: [
            'https://profitads.ru/?agent_id=6698B632DBC61',
            'https://lk.profitads.ru/registration/6698B632DBC61',
          ],
        },
        {
          name: 'Вконтакте 3%',
          id: '674EF9911E96C',
          urls: [
            'https://profitads.ru/?agent_id=6698B632DBC61',
            'https://lk.profitads.ru/registration/6698B632DBC61',
          ],
        },
        {
          name: 'My Target 10%',
          id: '674EF9911E96C',
          urls: [
            'https://profitads.ru/?agent_id=6698B632DBC61',
            'https://lk.profitads.ru/registration/6698B632DBC61',
          ],
        },
        {
          name: 'Facebook 15%',
          id: '674EF9911E96C',
          urls: [
            'https://profitads.ru/?agent_id=6698B632DBC61',
            'https://lk.profitads.ru/registration/6698B632DBC61',
          ],
        },
      ],
    };
  },
  async beforeMount() {
    if (this.user && this.user.agent && Object.keys(this.user.agent).length) {
      this.getUsers();
      this.getAgentListLinks();
    }
  },
  computed: {
    ...mapState('Referrals', ['agentsLinksList']),
    pagination() {
      return this.$store.state.Support.helpdeskPagination;
    },
    user() {
      return this.$store.state.Auth.user;
    },
    usersList() {
      return this.$store.state.Referrals.usersList;
    },
    agent() {
      return this.$store.state.Auth.user.agent;
    },
    link() {
      return this.agent?.link;
    },
    agentId() {
      return this.agent?.referral_code;
    },
    agentLink() {
      return `https://profitads.ru/?agent_id=${this.agentId}`;
    },
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        if (this.user && this.user.agent && Object.keys(this.user.agent).length) {
          this.getUsers();
          this.getAgentListLinks();
        }
      },
    },
  },
  methods: {
    loginBusinessAccount(businessAccountId) {
      const data = {
        id: businessAccountId,
        token: localStorage.getItem('token'),
      };
      this.isLoadingBusinessAccount = true;

      this.$store.dispatch('Auth/authAsUser', data).then(async () => {
        await this.$router.replace({ name: 'Home' });
        this.isLoadingBusinessAccount = false;
      });
    },
    openPrepaidDialog() {
      this.$store.commit('Dialog/setData', { label: 'activeDialog', data: 'CreateReferralLInk' });
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });
    },
    openReferralDialog(referralId) {
      this.$store.commit('Dialog/setData', { label: 'activeDialog', data: 'ShowReferralLink' });
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });
      this.$store.commit('Dialog/setData', {
        label: 'dialogData',
        data: { referralId, agent: this.agent },
      });
    },
    changeSearchText(val) {
      if (!val) {
        const query = { ...this.$route.query, page: 1, search_text: null };
        this.$router.push({ query });
      } else {
        const query = { ...this.$route.query, page: 1, search_text: val };
        this.$router.push({ query });
      }
    },
    showMore() {
      this.currentPage++;
      this.getHelpdesk();
    },
    getHelpdesk() {
      this.$store.dispatch('Support/getHelpdesk', {
        status: this.activeTab,
        page: this.currentPage,
      });
    },
    copyReferralLink(link) {
      this.$copyText(link).then(
        () => {
          this.$notify({
            message: this.$t('referral_data.copied'),
            type: 'success',
          });
        },
        function () {
          this.$notify({
            message: this.$t('referral_data.error'),
            type: 'error',
          });
        }
      );
    },
    doCopy() {
      this.$copyText(this.link).then(
        () => {
          this.$notify({
            message: this.$t('referral_data.copied'),
            type: 'success',
          });
        },
        function () {
          this.$notify({
            message: this.$t('referral_data.error'),
            type: 'error',
          });
        }
      );
    },
    sendInvitations() {
      reachMetrikaGoal(this, METRIKA_GOALS.SEND_INVITATIONS);
      this.doCopy();
    },
    doCopyAgentLink() {
      this.$copyText(this.agentLink).then(
        () => {
          this.$notify({
            message: this.$t('referral_data.copied'),
            type: 'success',
          });
        },
        function () {
          this.$notify({
            message: this.$t('referral_data.error'),
            type: 'error',
          });
        }
      );
    },
    getUsers() {
      const clientToken = localStorage.getItem('client_token');
      const data = {
        token: clientToken,
        id: this.user.agent.id,
      };
      this.$store.dispatch('Referrals/getUsers', data);
    },
    getAgentListLinks() {
      const clientToken = localStorage.getItem('client_token');
      const data = {
        token: clientToken,
        id: this.user.agent.id,
      };
      this.$store.dispatch('Referrals/getAgentListLinks', data);
    },
    getDetailStatistics(id) {
      const clientToken = localStorage.getItem('client_token');
      this.$router.push({ query: { user_id: id } });
      this.$store.commit('Dialog/setData', { label: 'activeDialog', data: 'AgentTransactionsXLS' });
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });

      const data = {
        token: clientToken,
        agent: id,
      };

      // this.$store.dispatch('Referrals/getDetailStatistics', data)
      //     .then(() => {
      //         this.$notify({
      //             message: this.$t('prepaid.notify_messages.2'),
      //             type: 'success'
      //         });
      //     })
      //     .catch((error) => {
      //         this.$notify({
      //             message: error,
      //             type: 'error'
      //         });
      //     })
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.hovered {
  background-color: #f5f7fa;
}

.tooltip-wrapper {
  transform: translateY(-50%);
  top: 50%;
}

.referral-statistics {
  display: flex;
  flex-direction: column;
  // align-items: center;

  &__row-actions {
    display: flex;
    align-items: center;
    gap: 3rem;
  }

  &__login-business-account-btn {
    background: none;
    border: none;
    appearance: none;
  }

  .app-add-business-account {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    text-align: center;
    margin: auto;
    margin-top: 10rem;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 5rem;
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 1.2rem;

    &:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }
  }

  &-header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    column-gap: 20px;
    margin-bottom: 20px;
  }

  &__search {
    display: flex;
    width: 100%;
    justify-content: space-between;
    column-gap: 7rem;
    min-height: 5rem;
    margin-bottom: 2rem;
  }

  &__table-title {
    margin-bottom: 1.4rem;
    color: #9ba2ab;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &__tabs {
    width: 100%;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__tab {
    background: #e6eaf2;
    padding: 16px 40px;
    color: #9ba2ab;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.75px;
    border-radius: 7.64px;
    text-wrap: nowrap;
    cursor: pointer;

    &.active {
      background: #d6e0f2;
      color: #333333;
      box-shadow: 0px 5px 10px 0px #9e9e9e1a;
    }
  }

  &-button__create {
    visibility: hidden;
    /* opacity: 0; */
    border: 1.5px solid #2f80ed;
    padding: 10px 0; //check
    width: 100%;
    max-width: 330px;
    text-align: center;
    background: transparent;
    color: #395fe4;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 700;
    line-height: 18.75px;

    &.active {
      visibility: visible;
      /* opacity: 1; */
    }
  }
}

.referral_list {
  display: flex;
  flex-direction: column;

  &-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    height: 84px;
    border-bottom: 1px solid #00000026;
  }

  &-name {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}

.referral_link {
  display: flex;
  flex-direction: column;
  padding: 0.8rem 1.6rem;
  border-radius: 4px;
  border: 1.5px solid var(--primary);
  background: var(--primary);
  color: #fff;
  max-width: 50rem;
  width: 100%;
  row-gap: 0.5rem;

  &__title {
    font-family: 'Roboto';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &__value {
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__wrapper {
    display: flex;
  }

  &__copy {
    margin-left: 0.6rem;

    &:hover {
      cursor: pointer;
    }
  }

  &__block {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
}

.button-style {
  color: #fff;
  background-color: var(--primary);
  font-family: 'Roboto';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 12px 19px 14px 17px;
  border-radius: 4px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
}

.el-table {
  .el-table__cell {
    padding-left: 1rem;
    padding-right: 1.2rem;
  }
}

@include below(769px) {
  .referral-statistics {
    &__row {
      flex-direction: column;
      row-gap: 1.2rem;

      .button-style {
        width: 100%;
      }
    }
  }
}
</style>
